import logger from '../log';
import { ElevenAgentData } from './interfaces';
import { safeSave, safeGet } from '../util/storage';
import BaseLogger from '../log/Logger';

const log = logger.getLogger(__filename);

const elevenData = 'ksdk::common::eleven::agentData';

export function setElevenData(data: ElevenAgentData | undefined): void {
  safeSave({
    error: 'Failed setting Eleven Data',
    key: elevenData,
    log: log as BaseLogger,
    data: data || {}
  });
}

// Typescript doesn't like the {} type. So we use Record as the alternate for {}
export function getElevenData(): ElevenAgentData | Record<string, unknown> {
  return safeGet({
    error: 'Failed fetching Eleven Data',
    nonExistenceError: 'No Eleven Data to fetch',
    default: {},
    log: log as BaseLogger,
    key: elevenData
  });
}
